module.exports = __webpack_public_path__ + "1070561d125427f3abe31962b993fe1c.pdf";